var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":'#' + _vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }